export default {
	options: [{
		value: '0',
		label: '上海速元科技有限公司'
	}, {
		value: '1',
		label: '上海速元科技有限公司'
	}],

	searchlist: [{
		prop: "companyName",
		label: '公司名称',
		type: "input"
	}, {
		prop: "expenseAccountNumber",
		label: '报销单号',
		type: "input",
	}, {
		label: "记账日期",
		prop: "bookkeepingDate",
		type: "date"
	},{
		prop: "period",
		label: '所属期',
		type: "datemonth",
		valueformat: 'yyyyMM'
	}, {
		prop: "name",
		label: '姓名',
		type: "input"
	}, {
		prop: "dept",
		label: '部门',
		type: "input"
	}, {
		prop: "expenseType",
		label: '费用类型',
		type: "input"
	}, {
		prop: "approvedBy",
		label: '审核通过人',
		type: "input"
	}],
	tableData: [],
	searchdata: {
		companyName: "",
		expenseAccountNumber: "",
		name: "",
		dept: "",
		expenseType: "",
		approvedBy: "",
	},
	headData: [{
		title: "公司名称",
		prop: "companyName",
		width: 160,
		align: "left"
	}, {
		title: "报销单号",
		prop: "expenseAccountNumber",
		width: 160,
		align: "left"
	}, {
		title: "姓名",
		prop: "name",
		width: 80
	}, {
		title: "部门",
		prop: "dept",
		width: 80
	}, {
		title: "费用金额",
		prop: "expenseAmount",
		width: 80,
		AmountFormat: true,
		align: "right"
	}, {
		title: "税率",
		prop: "taxRate",
		custom: true,
		width: 80
	}, {
		title: "税额",
		prop: "tax",
		width: 80,
		AmountFormat: true,
		align: "right"
	}, {
		title: "不含税金额",
		prop: "amountExcludingTax",
		width: 80,
		AmountFormat: true,
		align: "right"
	}, {
		title: "记账日期",
		prop: "bookkeepingDate",
		width: 80
	}, {
		title: "费用类型",
	}, {
		title: "审核通过人",
		prop: "approvedBy",
		width: 80
	},{
		title: "操作",
		prop: "cz",
		width: "200",
		fixed:"right",
		custom:true
	},],
	outputData: {
		exportType: "",
		shenbq: "",
	},
	pagination: {
		pageNum: 1,
		pageSize: 50,
		total: 0,
		paginationkey: 0
	}
}
